declare global {
  interface Window {
    __BUOY_X_CONFIG__?: {
      apiUrl?: string;
      mapStyleLight?: string;
      mapStyleDark?: string;
    };
  }
}

const buildEnv =
  (import.meta as ImportMeta & { env?: Record<string, string | undefined> })
    .env ?? {};

export const runtimeConfig = {
  apiUrl:
    window.__BUOY_X_CONFIG__?.apiUrl ??
    buildEnv.VITE_API_URL ??
    "http://localhost:3000",
  mapStyleLight:
    window.__BUOY_X_CONFIG__?.mapStyleLight ??
    buildEnv.VITE_MAP_STYLE_LIGHT ??
    "https://tiles.openfreemap.org/styles/liberty",
  mapStyleDark:
    window.__BUOY_X_CONFIG__?.mapStyleDark ??
    buildEnv.VITE_MAP_STYLE_DARK ??
    "https://tiles.openfreemap.org/styles/dark",
};
